var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title tec",class:{'line':_vm.line}},[_c('h2',{staticClass:"b"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('p',{staticClass:"c9"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }